import {CustomerGroupList} from "./CustomerGroupList";
import {CustomerGroupEdit} from "./CustomerGroupEdit";
import {CustomerGroupCreate} from "./CustomerGroupCreate";

export default {
    list: CustomerGroupList,
    create: CustomerGroupCreate,
    edit: CustomerGroupEdit
};
